import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { Watch, ArrowRight } from 'lucide-react';
import { useToolTheme } from '@/contexts/ThemeContext';

export function AdminQuickAccess() {
  const navigate = useNavigate();
  const { toolColors } = useToolTheme();

  return (
    <Card className="hover:shadow-lg transition-all">
      <CardContent className="p-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="p-2 rounded-lg" style={{ backgroundColor: `${toolColors.primary}15` }}>
              <Watch className="w-5 h-5" style={{ color: toolColors.primary }} />
            </div>
            <div>
              <h3 className="font-medium">Projector Watch</h3>
              <p className="text-sm text-gray-500">Accès administrateur</p>
            </div>
          </div>
          <Button
            onClick={() => navigate('/projector-watch')}
            className="gap-2"
            style={{ 
              backgroundColor: toolColors.primary,
              color: 'white'
            }}
          >
            Accéder
            <ArrowRight className="w-4 h-4" />
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}